"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _ModalNewApplicationEquipment = _interopRequireDefault(require("./components/ModalNewApplicationEquipment"));
var _vuex = require("vuex");
var _application = require("@/services/application.service");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'Equipamentos',
  components: {
    Page: _Page.default
  },
  data: function data() {
    return {
      currentPage: 1,
      perPage: 20,
      dateStart: (0, _moment.default)().startOf('year').toDate(),
      dateEnd: (0, _moment.default)().endOf('year').toDate(),
      total: 0,
      list: [],
      tipos: ['Pulverizador manual', 'Pulverizador bomba', 'Pulverizador borrifador', 'Pulverizador costal']
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)({
    menuItems: 'menuItemsApplications',
    isLoading: 'isLoading',
    farm: 'GET_FARM'
  })),
  watch: {
    'farm.id': {
      handler: function handler(newVal) {
        if (newVal) {
          this.loadAsyncDataList();
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    this.loadAsyncDataList();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['saveNewApplicationEquipment', 'editApplicationEquipment', 'deleteApplicationEquipment'])), {}, {
    onPageChange: function onPageChange(i) {
      this.currentPage = i;
      this.loadAsyncDataList();
    },
    loadAsyncDataList: function () {
      var _loadAsyncDataList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$farm;
        var params, _yield$applicationSer, response, _response$meta, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if ((_this$farm = this.farm) !== null && _this$farm !== void 0 && _this$farm.id) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              params = {
                startDate: (0, _moment.default)(this.dateStart).format('YYYY-MM-DD'),
                endDate: (0, _moment.default)(this.dateEnd).format('YYYY-MM-DD'),
                page: this.currentPage,
                limit: this.perPage
              };
              _context.n = 2;
              return _application.applicationService.fetchEquipmentsByDateRange(this.farm.id, params);
            case 2:
              _yield$applicationSer = _context.v;
              response = _yield$applicationSer.data;
              if (response && response.data && Array.isArray(response.data)) {
                this.list = response.data.map(function (equipment) {
                  return {
                    id: equipment.id,
                    nome: equipment.name,
                    fabricante: equipment.supplier,
                    tipo: equipment.type,
                    observacao: equipment.observation
                  };
                });
                this.total = ((_response$meta = response.meta) === null || _response$meta === void 0 ? void 0 : _response$meta.total) || this.list.length;
              } else {
                this.list = [];
                this.total = 0;
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.list = [];
              this.total = 0;
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function loadAsyncDataList() {
        return _loadAsyncDataList.apply(this, arguments);
      }
      return loadAsyncDataList;
    }(),
    openEquipmentModal: function openEquipmentModal() {
      var equipment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.$buefy.modal.open({
        parent: this,
        component: _ModalNewApplicationEquipment.default,
        hasModalCard: false,
        customClass: 'modal-new-application-equipment',
        trapFocus: true,
        canCancel: ['escape'],
        props: {
          equipment: equipment,
          tipos: this.tipos,
          onSuccess: this.resolvedCallback,
          createEquipment: this.createEquipment,
          updateEquipment: this.updateEquipment
        }
      });
    },
    verifyDelete: function verifyDelete(item) {
      var _this = this;
      this.$buefy.dialog.confirm({
        title: 'Excluir Equipamento',
        message: "Tem certeza de que deseja <b>excluir</b> o equipamento \"".concat(item.nome, "\"? <b>Essa a\xE7\xE3o n\xE3o poder\xE1 ser desfeita.</b>"),
        cancelText: 'Cancelar',
        confirmText: 'Excluir',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function onConfirm() {
          return _this.deleteEquipment(item);
        }
      });
    },
    deleteEquipment: function () {
      var _deleteEquipment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(item) {
        var _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return _application.applicationService.deleteEquipment(item.id, this.farm.id);
            case 1:
              this.$buefy.toast.open({
                message: "Equipamento \"".concat(item.nome, "\" exclu\xEDdo com sucesso!"),
                type: 'is-success'
              });
              this.loadAsyncDataList();
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              this.$buefy.toast.open({
                message: 'Erro ao excluir equipamento. Tente novamente.',
                type: 'is-danger'
              });
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function deleteEquipment(_x) {
        return _deleteEquipment.apply(this, arguments);
      }
      return deleteEquipment;
    }(),
    createEquipment: function () {
      var _createEquipment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(form) {
        var data, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              data = {
                name: form.nome,
                supplier: form.fabricante,
                type: form.tipo,
                observation: form.observacao,
                farmId: this.farm.id
              };
              _context3.n = 1;
              return _application.applicationService.createEquipment(data);
            case 1:
              this.$buefy.toast.open({
                message: 'Equipamento criado com sucesso!',
                type: 'is-success'
              });
              return _context3.a(2, true);
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              this.$buefy.toast.open({
                message: 'Erro ao criar equipamento. Tente novamente.',
                type: 'is-danger'
              });
              return _context3.a(2, false);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function createEquipment(_x2) {
        return _createEquipment.apply(this, arguments);
      }
      return createEquipment;
    }(),
    updateEquipment: function () {
      var _updateEquipment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(form, equipment) {
        var data, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              data = {
                name: form.nome,
                supplier: form.fabricante,
                type: form.tipo,
                observation: form.observacao,
                farmId: this.farm.id
              };
              _context4.n = 1;
              return _application.applicationService.updateEquipment(equipment.id, data);
            case 1:
              this.$buefy.toast.open({
                message: 'Equipamento editado com sucesso!',
                type: 'is-success'
              });
              return _context4.a(2, true);
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              this.$buefy.toast.open({
                message: 'Erro ao editar equipamento. Tente novamente.',
                type: 'is-danger'
              });
              return _context4.a(2, false);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function updateEquipment(_x3, _x4) {
        return _updateEquipment.apply(this, arguments);
      }
      return updateEquipment;
    }(),
    resolvedCallback: function resolvedCallback() {
      this.currentPage = 1;
      this.loadAsyncDataList();
    },
    truncateText: function truncateText(text, maxLength) {
      if (!text) return '--';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    }
  })
};